import { MEASUREMENT_ID, AnalyticsWindow } from '../types';

/**
 * Desativa o Google Analytics nativamente, remove todos os cookies _ga
 * em todos os subdomínios e caminhos possíveis, e recarrega a página se já inicializada.
 */
export function disableAnalytics(): void {
  const analytics = window as AnalyticsWindow;
  analytics[`ga-disable-${MEASUREMENT_ID}`] = true;
  const domains = window.location.hostname.split('.');
  const paths = window.location.pathname.split('/');

  document.cookie.split(';').forEach((cookie) => {
    const name = cookie.trim().split('=')[0];
    if (name !== '_ga' && !name.startsWith('_ga_')) return;

    for (let pathIndex = 1; pathIndex <= paths.length; pathIndex += 1) {
      const path = paths.slice(0, pathIndex).join('/') || '/';
      const expired = `${name}=; Max-Age=0; path=${path};`;
      document.cookie = expired;

      for (let index = 0; index < domains.length - 1; index += 1) {
        document.cookie = `${expired} domain=${domains
          .slice(index)
          .join('.')};`;
      }
    }
  });

  if (analytics.delpsAnalyticsInitialized) {
    window.location.reload();
  }
}
